module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modules/angular5-data-table/all-tickets-old/all-tickets-old.component.scss
// module id = ./src/app/shared/modules/angular5-data-table/all-tickets-old/all-tickets-old.component.scss
// module chunks = main